import { Badge } from "@/components/ui/badge";
import { CheckCircle, Clock, XCircle } from "lucide-react";

type CampaignStatus = "ACTIVE" | "FUTURE" | "EXPIRED";

interface CampaignStatusBadgeProps {
  status: CampaignStatus;
  showIcon?: boolean;
}

export function CampaignStatusBadge({ status, showIcon = true }: CampaignStatusBadgeProps) {
  const config = {
    ACTIVE: {
      label: "Ativa",
      variant: "default" as const,
      icon: CheckCircle,
      className: "bg-green-100 text-green-700 border-green-300",
    },
    FUTURE: {
      label: "Futura",
      variant: "default" as const,
      icon: Clock,
      className: "bg-blue-100 text-blue-700 border-blue-300",
    },
    EXPIRED: {
      label: "Expirada",
      variant: "secondary" as const,
      icon: XCircle,
      className: "bg-gray-100 text-gray-700 border-gray-300",
    },
  };

  const { label, icon: Icon, className } = config[status] || config.ACTIVE;

  return (
    <Badge variant="outline" className={`${className} font-medium`}>
      {showIcon && <Icon className="w-3 h-3 mr-1" />}
      {label}
    </Badge>
  );
}
